/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для аналогов товаров c нулевым балансом в корзине.
   */
  app.PersonalRecommendationsCartAnalogView = app.PersonalRecommendationsView.extend({
    /**
     * @inheritDoc
     */
    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.listenTo(app.currencies, 'change:current', this.fetchNewPrices);
      this.render();
      this.listenToOnce(this, 'showAnalogs', this.initOkoWatcher.bind(this, null, new app.Model()));
    },

    /**
     *  Рендер рекомендаций
     */
    render: function () {
      var model = this.model.toJSON();
      this.setTitle();
      this.$('.carousel-container').html(this.template({
        recommendedItems: model.items ? model.items : model,
        title: '',
        withDisinterestBtn: this.withDisinterestBtn
      }));
      if (this.$('.recommendation-list').length) {
        var recommendationElement = this.$('.recommendation-list');
        this.recommendationsCarouselView = new app.RecommendationsCarouselView({
          el: recommendationElement,
          items: model.items || null,
          cart: this.cart,
        });
      }
      if( this.childViews.okoWatcher ) {
        this.childViews.okoWatcher.updateWatcher();
      }
    },

    /**
     * Формирование тайтла
     * @return {*}
     */
    setTitle: function () {
      var items = this.model.get('items');
      var countItems = Array.isArray(items) ? items.length : null;
      if (countItems > 0) {
        var analog = '';
        if (app.locale === app.LOCALES.ru) {
          analog = app.helpers.DeclinationHelper.format(countItems, ['аналог', 'аналога', 'аналогов']);
        } else {
          analog = 'similar';
        }
        var qtyAnalogs = countItems + ' ' + analog;
        // устанавливаем кол-во аналогов в заголовок и блок с аналогами
        this.$('.recommendations-analog-count').text(qtyAnalogs);
      }
    },
  });
})();

}.call(window));